import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでモデル学習の中止が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

function AxiosDelete(url: string, token?: string) {
  if (token) {
    return axios.delete(url, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.delete(url);
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IStopTrainModelParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;  
}

/**
 * 実行中のモデル学習を中止します
 * @function stopTrainModel
 * @param {IStopTrainModelParams} params - モデル学習中止パラメータ
 */
export function stopTrainModel(params: IStopTrainModelParams): void {
  const { authService, projectid } = params;
  const url = WebAPI.DELETE_MODEL(projectid);
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosDelete(url, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              stopTrainModelRetry401(authService, url, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosDelete(url),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * 実行中のモデル学習を中止します
 * @function stopTrainModelRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {ICallbackParams} params - コールバックパラメータ
 */
 function stopTrainModelRetry401(
  authService: AuthService, 
  url: string,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosDelete(url, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}